import axios from 'axios'

import type { AppError } from '@/types/site'

export function normalizeApiError(error: unknown): AppError {
  if (axios.isAxiosError(error)) {
    if (!error.response) {
      return {
        type: 'network',
        message: 'Unable to reach the server. Please check your connection.',
      }
    }

    if (error.response.status >= 500) {
      return {
        type: 'server',
        message: 'A server issue interrupted the request.',
        statusCode: error.response.status,
      }
    }

    return {
      type: 'unknown',
      message: error.response.data?.message ?? error.message,
      statusCode: error.response.status,
    }
  }

  if (error instanceof Error) {
    return {
      type: 'unknown',
      message: error.message,
    }
  }

  return {
    type: 'unknown',
    message: 'An unexpected application error occurred.',
  }
}
